import httpClient from '~/lib/http-client';

/** One message as it read in Dunea Work. `worked` is its plain summary ("Searched the web 3 times · Created a file"). */
export type SharedWorkMessage =
  | { role: 'user'; text: string }
  | { role: 'assistant'; text: string; worked?: string; files?: string[] };

export interface SharedWorkFile {
  name: string;
  size: number;
  url: string;
}

export interface SharedWork {
  id: string;
  title: string;
  author: string | null;
  createdAt: string;
  updatedAt: string;
  messages: SharedWorkMessage[];
  files: SharedWorkFile[];
}

/** A Dunea Work chat someone shared — public, no sign-in (GET /api/shared/work/:id). */
export async function apiGetSharedWork(id: string): Promise<SharedWork> {
  const { data } = await httpClient.get<SharedWork>(`/api/shared/work/${encodeURIComponent(id)}`);
  return data;
}
